<div class="flex gap-3 items-center">
  <ui-select class="md:flex-none w-full md:w-60" (selectChange)="selectChange.emit($event)">
    <option value="" [selected]="selectedYear() === ''">
      {{ 'cockpit.analysis.hpfc.detail.comparisonSelect' | transloco }}
    </option>
    @for (year of historicYears(); track year.year) {
      <option
        [value]="year.year"
        [selected]="selectedYear() === '' + year.year"
        [disabled]="!year.state?.data"
      >
        {{ 'cockpit.analysis.hpfc.legend.comparison' | transloco: { year: year.year } }}
      </option>
    }
  </ui-select>
  <ui-button
    class="hidden md:block"
    mode="outlined"
    [disabled]="selectedYear() === ''"
    (click)="selectChange.emit('')"
  >
    {{ 'cockpit.analysis.hpfc.detail.resetButton' | transloco }}
  </ui-button>
</div>
